import 'angular:locale/data:de-CH';(globalThis.$localize ??= {}).locale = "de-CH";
